<div class="sidenav-content copo-datacenter-sidenav-content" @routeAnimation>
	<div class="copo-datacenter-flex-box">
		<div class="copo-datacenter-title-block">
			<div class="copo-datacenter-title-label" translate>{{ datacenterTitle }}</div>
			<div *ngIf="dataCenterType()">
				<button class="copo-datacenter-button download-btns" type="button" [disabled]="selectionService.selectedCount === 0 && !selectionService.isAllSelected"
				*ngIf="!isAqdbDataCenter"
				(click)="isDocumentDatacenter?exportAsZipData():detailedReport()"
				mat-flat-button>
					<span>{{buttonName}}</span>
					<mat-icon iconPositionEnd color="accent" [svgIcon]="isDocumentDatacenter?'md:zipPdf':'md:download'"></mat-icon>
				</button>
				<button class="copo-datacenter-button" *ngIf="isDocumentDatacenter" type="button" [disabled]="selectionService.selectedCount === 0 && !selectionService.isAllSelected"
				(click)="collateDocuments()"
				mat-flat-button>
					<span translate>datacenter-filter.collate-documents</span>
					<mat-icon iconPositionEnd color="accent" svgIcon="md:download"></mat-icon>
				</button>
				<button class="copo-datacenter-button" type="button"
					[disabled]="selectionService.selectedCount === 0 && !selectionService.isAllSelected"
					(click)="exportAqdbBatchData()" *ngIf="isAqdbDataCenter" cdkFocusInitial mat-flat-button>
					<span translate>sb.Download</span>
					<mat-icon iconPositionEnd color="accent" svgIcon="md:download"></mat-icon>
				</button>
			</div>
		</div>
		<copo-datacenter-tool-header
				class="copo-datacenter-header"
				[customizeViewDisabled]="datacenterLuceneFilterService.isLoadingFilters"
				[canResetFilters]="numberOfFiltersApplied > 0"
				[currentView]="currentSelectedView"
				[download]="exportExcelData.bind(this)"
				[nbResults]="count"
				[nbSelectedResults]="selectionService.selectedCount"
				[views]="userViews"
				(customizeView)="goToCustomizeView()"
				(resetFilters)="resetFiltersInHeader()"
				(viewChange)="setCurrentViewAndColumnState($event)">
		</copo-datacenter-tool-header>
		<ag-grid-angular
			#agGrid
			class="ag-theme-balham copo-datacenter-grid"
			[modules]="agGridModules"
			(gridReady)="onGridReady($event)"
			[gridOptions]="gridOptions"
			(rowSelected)="onRowSelected($event)"
			(viewportChanged)="filtersChanged()">
		</ag-grid-angular>
	</div>
</div>
